import React from "react";
import { useTranslation } from "react-i18next";
import { ScrollableContainer, StyledPageWrapper, Title } from "@monorepo/components";

import ServiceForm from "components/ServiceForms/ServiceForm";
import { FormWrapper, PageWrapper } from "components/Services/ServicesPage";

interface ISingleServiceProps {
  id?: string;
  ignoreGroup: boolean;
  redirectOnServiceGroupSelect?: (id: string) => string;
}

const SingleService: React.FC<ISingleServiceProps> = ({ id, ignoreGroup, redirectOnServiceGroupSelect }) => {
  const { t } = useTranslation();
  return (
    <StyledPageWrapper>
      <PageWrapper>
        <ScrollableContainer>
          <FormWrapper>
            <Title>{t("payments.new_payment")}</Title>
            {id && (
              <ServiceForm
                id={id}
                ignoreGroup={ignoreGroup}
                redirectOnServiceGroupSelect={redirectOnServiceGroupSelect}
              />
            )}
          </FormWrapper>
        </ScrollableContainer>
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default SingleService;
